module.exports = __webpack_public_path__ + "img/pr-18.02d2c806.png";